"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteResolutionStrategy = void 0;
var RouteResolutionStrategy;
(function (RouteResolutionStrategy) {
    RouteResolutionStrategy[RouteResolutionStrategy["LocationProximityOnly"] = 0] = "LocationProximityOnly";
    RouteResolutionStrategy[RouteResolutionStrategy["LocationProximityAndRadius"] = 1] = "LocationProximityAndRadius";
})(RouteResolutionStrategy || (exports.RouteResolutionStrategy = RouteResolutionStrategy = {}));
//# sourceMappingURL=route-resolution-strategy.enum.js.map